var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRatingGreen = function SvgRatingGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 25,
    r: 19,
    fill: "url(#rating-green_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rating-green_svg__b)",
    d: "M15.772 57.37A16 16 0 0 1 31.554 44h16.892a16 16 0 0 1 15.782 13.37l1.337 8.018c.29 1.738.435 3.498.435 5.26V74H14v-3.352c0-1.762.146-3.522.435-5.26l1.337-8.018Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M16.053 48.892a.5.5 0 0 1 .894 0l2.958 5.899a.5.5 0 0 0 .392.273l6.938.757a.5.5 0 0 1 .27.877l-5.07 4.314a.5.5 0 0 0-.165.486l1.354 6.271a.5.5 0 0 1-.718.55l-6.177-3.181a.5.5 0 0 0-.458 0l-6.177 3.181a.5.5 0 0 1-.718-.55l1.354-6.27a.5.5 0 0 0-.164-.487l-5.07-4.314a.5.5 0 0 1 .27-.877l6.937-.757a.5.5 0 0 0 .392-.273l2.958-5.9ZM39.542 49.037a.5.5 0 0 1 .916 0l2.531 5.738a.5.5 0 0 0 .396.294l6.039.749a.5.5 0 0 1 .286.855l-4.494 4.345a.5.5 0 0 0-.144.453l1.188 6.252a.5.5 0 0 1-.743.525l-5.265-3.08a.5.5 0 0 0-.505 0l-5.264 3.08a.5.5 0 0 1-.743-.525l1.188-6.252a.5.5 0 0 0-.144-.453l-4.494-4.345a.5.5 0 0 1 .286-.855l6.039-.749a.5.5 0 0 0 .396-.294l2.531-5.738ZM63.053 48.892a.5.5 0 0 1 .894 0l2.958 5.899a.5.5 0 0 0 .392.273l6.938.757a.5.5 0 0 1 .27.877l-5.07 4.314a.5.5 0 0 0-.166.486l1.355 6.271a.5.5 0 0 1-.718.55l-6.177-3.181a.5.5 0 0 0-.458 0l-6.177 3.181a.5.5 0 0 1-.718-.55l1.355-6.27a.5.5 0 0 0-.165-.487l-5.07-4.314a.5.5 0 0 1 .27-.877l6.937-.757a.5.5 0 0 0 .392-.273l2.958-5.9Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rating-green_svg__a",
    x1: 59.464,
    x2: 20.98,
    y1: 24.413,
    y2: 24.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rating-green_svg__b",
    x1: 66.635,
    x2: 13.973,
    y1: 58.536,
    y2: 58.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgRatingGreen;